import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useRef, useState } from "react";

const AudioPlayer = ({ src, mimeType, showPlayBackSpeed=false, matches}) => {
  const audioPlayerRef = useRef(null);
  const [playbackRate, setPlaybackRate] = useState(1);

  const changePlaybackRate = (rate) => {
    if (audioPlayerRef.current) {
      audioPlayerRef.current.playbackRate = rate;
      setPlaybackRate(rate);
    }
  };

  return (
    showPlayBackSpeed
      ? <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          p: matches ? 1 : 2,
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px solid #e0e0e0'
        }}>
          <audio
            controls
            key={src}
            ref={audioPlayerRef}
            controlsList="nodownload"
            style={{
              width: '100%',
              height: matches ? '40px' : '45px',
              borderRadius: '8px',
              outline: 'none'
            }}
          >
            <source src={src} type={mimeType} />
            Your browser does not support the audio element.
          </audio>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            px: 1.5,
            py: 0.5,
            border: '1px solid #e0e0e0'
          }}>
            <Typography variant="caption" sx={{
              fontSize: matches ? '0.7rem' : '0.75rem',
              color: '#666',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}>
              Speed:
            </Typography>
            <FormControl variant="standard" sx={{ minWidth: "55px" }}>
              <Select
                labelId="playback-speed-label"
                value={playbackRate}
                onChange={(e) => changePlaybackRate(Number(e.target.value))}
                disableUnderline
                sx={{
                  fontSize: matches ? '0.75rem' : '0.875rem',
                  fontWeight: 600,
                  color: '#1976d2',
                  '& .MuiSelect-select': {
                    padding: '4px 8px',
                  }
                }}
              >
                <MenuItem value={0.5} sx={{ fontSize: matches ? '0.75rem' : '0.875rem' }}>0.5x</MenuItem>
                <MenuItem value={1} sx={{ fontSize: matches ? '0.75rem' : '0.875rem' }}>1x</MenuItem>
                <MenuItem value={1.5} sx={{ fontSize: matches ? '0.75rem' : '0.875rem' }}>1.5x</MenuItem>
                <MenuItem value={2} sx={{ fontSize: matches ? '0.75rem' : '0.875rem' }}>2x</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      : <Box sx={{
          p: 2,
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px solid #e0e0e0'
        }}>
          <audio
            controls
            key={src}
            ref={audioPlayerRef}
            controlsList="nodownload"
            style={{
              width: "100%",
              height: '45px',
              borderRadius: '8px',
              outline: 'none'
            }}
          >
            <source src={src} type={mimeType} />
            Your browser does not support the audio element.
          </audio>
        </Box>
  );
};

export default AudioPlayer;
